// Generated by `npm run data:coral-kinds` (scripts/data/coralKinds.ts) from the NCRMP extract in
// data/ncrmp-coral-demography/. Do not edit by hand: change the script and run it. tests/coralKinds.test.ts builds it
// again and fails if this file is not what the archive gives.

/** The coral's kinds (M176): the user's four and the rest of the reef's corals. */
export const CORAL_KINDS = ['lobe', 'finger', 'rice', 'cauliflower', 'other'] as const;
export type CoralKind = (typeof CORAL_KINDS)[number];

/**
 * Each stratum's live coral by kind (`stratumIndex` order, `CORAL_KINDS` order): the share of its adult colonies'
 * area, each colony's length squared clipped to its 1 x 2.5 m segment, of NOAA's 25443 adult colonies of a recorded length at Maui, Molokaʻi, Lānaʻi and
 * Kahoʻolawe, 2013 to 2024 (Ecosystem Sciences Division, Pacific Islands Fisheries Science Center (2024), NCRMP coral
 * demographic data, NCEI Accession 0298217, https://doi.org/10.25921/5qsa-z057; the subset
 * `scripts/data/coralSpecies.ts` names). MEASURED by the script.
 */
export const CORAL_KIND_SHARES: readonly (readonly number[])[] = [
  [0.338179, 0.152971, 0.205922, 0.033516, 0.269412],
  [0.232698, 0.2314, 0.192646, 0.071095, 0.272162],
  [0.198891, 0.221914, 0.378709, 0.035689, 0.164796],
  [0.245402, 0.043889, 0.198807, 0.099125, 0.412777],
  [0.11751, 0.228962, 0.3345, 0.052097, 0.26693],
  [0.082066, 0.261302, 0.356669, 0.045955, 0.254008],
  [0.431071, 0.049194, 0.099955, 0.101284, 0.318496],
  [0.248488, 0.291643, 0.244162, 0.019251, 0.196456],
  [0.21909, 0.278362, 0.281407, 0.035551, 0.18559],
  [0.279626, 0.043124, 0.050605, 0.104168, 0.522477],
  [0.175946, 0.179207, 0.232497, 0.021144, 0.391207],
  [0.166341, 0.058851, 0.448196, 0.042446, 0.284166],
];

/** The whole reef's live coral by kind, every colony's area pooled (the same colonies and measure): the kinds' weights where the coral's rates are taken as the reef's mean. MEASURED by the script. */
export const CORAL_KIND_REEF_SHARES: readonly number[] = [0.240112, 0.185952, 0.23129, 0.05247, 0.290177];
